module.exports = __webpack_public_path__ + "static/media/jquerry.b34e848e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/jquerry.png
// module id = 40
// module chunks = 0